import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { FAQS } from '../config/siteConfig';
import { trackEvent } from '../utils/analytics';
export function SingleProductFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  function toggleFaq(index: number) {
    const isOpening = openIndex !== index;
    setOpenIndex(isOpening ? index : null);
    if (isOpening) {
      trackEvent('faq_open', {
        cta_location: 'faq'
      });
    }
  }
  return <section id="preguntas" className="bg-[#0c0c1c] py-24" aria-labelledby="preguntas-title" data-id="element-1455">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-1456">
        <div className="text-center" data-id="element-1457">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-[#20d6e8]" data-id="element-1458">
            Información clara
          </p>
          <h2 id="preguntas-title" className="text-3xl font-bold text-white md:text-5xl" data-id="element-1459">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="mt-12 space-y-3" data-id="element-1460">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <article key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-[#101022]" data-id="element-1461">
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-content-${index}`} onClick={() => toggleFaq(index)} className="flex min-h-14 w-full items-center justify-between gap-5 px-5 py-4 text-left text-base font-semibold text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#20d6e8]" data-id="element-1462">
                  <span data-id="element-1463">{faq.question}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-[#20d6e8]" data-id="element-1464" /> : <PlusIcon className="h-5 w-5 flex-none text-[#a9a9ba]" data-id="element-1465" />}
                </button>

                <AnimatePresence initial={false} data-id="element-1466">
                  {isOpen && <motion.div id={`faq-content-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-1467">
                      <p className="px-5 pb-5 leading-relaxed text-[#a9a9ba]" data-id="element-1468">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}